export default __webpack_public_path__ + "static/media/SharePizza_14.2251dd62.png";